import Proptypes from 'prop-types';
import React from 'react';

const CollegeGiftingPortal = ({ height = '100%', width = '100%' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 150 108"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.504 102.143C114.504 105.38 96.5567 108 74.4182 108C52.278 108 34.3306 105.38 34.3306 102.143C34.3306 98.9092 52.278 96.2893 74.4182 96.2893C96.5567 96.2893 114.504 98.9092 114.504 102.143Z"
      fill="#E6F9FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      className="college-branded-icon-background"
      d="M76.0765 0C38.3829 0 7.82507 30.5666 7.82507 68.271C7.82507 78.3154 10.0108 87.8443 13.9063 96.4328H138.247C142.142 87.8443 144.328 78.3154 144.328 68.271C144.328 30.5666 113.77 0 76.0765 0Z"
      fill="#E6F9FB"
    />
    <path
      d="M8.67822 96.4329H141.768"
      className="college-branded-icon-stroke"
      stroke="#086EA1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 96.4329H5.26571"
      className="college-branded-icon-stroke"
      stroke="#086EA1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M145.181 96.4329H149.447"
      stroke="#00496A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="39" y="51" width="72" height="12" fill="white" />
    <path
      d="M83.7872 51C87.7025 49.7089 91.8018 48.0701 93.3728 46.4811C96.8708 42.9429 96.8708 37.1949 93.3728 33.6567C91.6791 31.9435 89.433 31 87.0397 31C84.6464 31 82.388 31.9435 80.6943 33.6567C78.5464 35.8293 76.3249 42.7194 74.9994 47.437C73.6738 42.7194 71.4523 35.8293 69.3045 33.6567C67.6107 31.9435 65.3524 31 62.959 31C60.5657 31 58.3197 31.9435 56.6259 33.6567C53.128 37.1949 53.128 42.9429 56.6259 46.4811C58.1969 48.0701 62.2963 49.7089 66.2115 51H83.7872ZM82.4249 35.4072C83.6522 34.1657 85.2846 33.4829 87.0274 33.4829C88.7703 33.4829 90.4026 34.1657 91.63 35.4072C94.1706 37.977 94.1706 42.1484 91.63 44.7182C89.6662 46.7045 81.4552 49.2247 76.6931 50.5158C77.9696 45.6989 80.4734 37.3935 82.4249 35.4072ZM58.3565 35.4072C59.5838 34.1657 61.2162 33.4829 62.959 33.4829C64.7019 33.4829 66.3343 34.1657 67.5616 35.4072C69.5254 37.3935 72.0169 45.6989 73.2934 50.5158C68.5312 49.2247 60.3202 46.7045 58.3565 44.7182C55.8159 42.1608 55.8159 37.977 58.3565 35.4072Z"
      className="college-branded-icon-bow"
      fill="#05C3DE"
    />
    <rect
      x="42.5"
      y="62.5"
      width="65"
      height="38"
      fill="white"
      stroke="#00496A"
    />
    <rect
      x="63.5"
      y="51.5"
      width="22"
      height="49"
      className="college-branded-icon-stripe"
      fill="white"
      stroke="#054C70"
    />
    <rect x="39.5" y="51.5" width="71" height="11" stroke="#00496A" />
  </svg>
);

CollegeGiftingPortal.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default CollegeGiftingPortal;
